import { ValidationResults } from '../../types'
import { countValidationResultsByLevel } from '../countValidationResultsByLevel'

export const hasBlockingValidationResults = (
  validationResults: ValidationResults
): boolean => {
  const errors = countValidationResultsByLevel({
    validationResults,
    level: 'ERROR'
  })

  return errors > 0
}
